import React from 'react';
import PropTypes from 'prop-types';

import OrderItem from './components/OrderItem';

const ReviewStep = ({
  orders,
  canDownloadPdf,
  downloadPdf,
}) => (
  <div>
    {
      orders.map(order => (
        <div className="u-mb+" key={order.id} >
          <OrderItem
            order={order}
            canDownloadPdf={canDownloadPdf}
            downloadPdf={() => downloadPdf(order)}
          />
        </div>
      ))
    }
  </div>
);

ReviewStep.propTypes = {
  orders: PropTypes.array.isRequired,
  canDownloadPdf: PropTypes.bool.isRequired,
  downloadPdf: PropTypes.func.isRequired,
};

export default ReviewStep;
